module.exports = __webpack_public_path__ + "static/media/matt-wilson-clouds.c9cc2b9e.png";